/***********************************************************************************
 * Vuelidate plugin
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import Vue from 'vue';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);
